import React from 'react';
import type { CompanyPrintInfo } from '@/components/sales-invoice/PrintableSalesInvoice';
import type { ApprovalPrintSigner } from '@/services/approval.service';
import type { SupplierAdvanceRequestPrintData } from '@/services/supplierAdvanceRequest.service';
import { EngineSarPrint } from '@/components/print/EngineLetterheadPrints';

export interface PrintableSupplierAdvanceRequestProps {
  data: SupplierAdvanceRequestPrintData;
  companyInfo?: CompanyPrintInfo;
  approvalSigners?: ApprovalPrintSigner[];
  onClose?: () => void;
}

/** SAR print — shared pagination engine with restored letter layout. */
export const PrintableSupplierAdvanceRequest: React.FC<PrintableSupplierAdvanceRequestProps> = ({
  data,
  companyInfo = { name: 'Company', address: '' },
  approvalSigners,
  onClose,
}) => {
  const sar = data.sar;
  return (
    <EngineSarPrint
      data={{
        advance_request_number: sar.advance_request_number,
        requested_date: sar.requested_date,
        currency: sar.currency || data.purchase_order?.currency,
        requested_amount: Number(sar.requested_amount ?? 0),
        purpose: sar.reason || sar.remarks,
        supplier_name: data.supplier?.supplier_name || data.purchase_order?.supplier_name,
        po_number: data.purchase_order?.po_number,
        payment_terms: (sar as any).payment_terms || data.purchase_order?.payment_terms,
        notes: sar.remarks || (sar as any).notes,
        bank_name: (sar as any).bank_name || (data.supplier as any)?.bank_name,
        bank_account: (sar as any).bank_account_number || (data.supplier as any)?.bank_account_number,
      }}
      companyInfo={companyInfo}
      approvalSigners={approvalSigners}
      onClose={onClose}
    />
  );
};
